module.exports = __webpack_public_path__ + "media/recipes/78-b11cb89f.png";